import error from '../../../../common/nodejs/errors';

/** 各フェーズ定義 */
export const PHASE = {
  /** 待機状態 */
  WAIT: 'wait',
  /** 実行状態: ブリード修正(1回目) */
  FIRST_EXECUTION: 'firstExecution',
  /** 実行監視状態: ブリード修正(1回目)*/
  FIRST_RUN_MONITORING: 'firstRunMonitoring',
  /** 実行状態: ブリード修正(2回目) */
  SECOND_EXECUTION: 'secondExecution',
  /** 実行監視状態: ブリード修正(2回目)  */
  SECOND_RUN_MONITORING: 'secondRunMonitoring',
  /** 実行状態: ブリード修正(3回目) */
  THIRD_EXECUTION: 'thirdExecution',
  /** 実行監視状態: ブリード修正(3回目) */
  THIRD_RUN_MONITORING: 'thirdRunMonitoring',
  /** 実行状態: ブリード修正(4回目)) */
  FOURTH_EXECUTION: 'fourthExecution',
  /** 実行監視状態: ブリード修正(4回目)*/
  FOURTH_RUN_MONITORING: 'fourthRunMonitoring',
  /** 実行状態: エア混入確認 */
  AIR_EXECUTION: 'airExecution',
  /** 実行監視状態: エア混入確認*/
  AIR_RUN_MONITORING: 'airRunMonitoring',
  /** 実行監視状態: TMC */
  TMC_RUN_MONITORING: 'tmcRunMonitoring',
  /** 実行状態: パイプ接続確認 */
  PIPE_EXECUTION: 'pipeExecution',
  /** 実行監視状態: パイプ接続確認*/
  PIPE_RUN_MONITORING: 'pipeRunMonitoring',
  /** 停止 */
  SUCCESS: 'success',
  /** エラー: 実行条件不成立表示 */
  EXECUTION_ERROR: 'executionError',
  /** エラー: 開始不可表示 */
  START_ERROR: 'startError',
  /** エラー: エア抜き失敗表示 */
  AIR_ERROR: 'airError',
  /** エラー: エア混入/フルード漏れテスト失敗表示*/
  AIR_FLUID_ERROR: 'airFluidError',
  /** エラー: ブレーキ異常表示 */
  BRAKE_ERROR: 'brakeError',
  /** エラー: パイプ異常表示*/
  PIPE_ERROR: 'pipeError',
  /** 共通エラー */
  FAILED: 'failed'
};

const HEADER_COLORS = {
  DANGER: 'danger',
  SUCCESS: 'success',
  SECONDARY: 'secondary'
};

const HEADER_TITLES = {
  CONFIRMATION: 'message.common_title_confirmation',
  EXECUTION: 'individual.common_title_execution',
  SUCCESS: 'message.common_title_success',
  ERROR: 'message.common_title_error'
};

/** phase毎の情報 */
export const PHASE_INFO = {
  [PHASE.WAIT]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_1`, showButtonOk: true },
  [PHASE.FIRST_EXECUTION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_2`, showButtonOk: true },
  [PHASE.FIRST_RUN_MONITORING]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_3`, showButtonOk: false },
  [PHASE.SECOND_EXECUTION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_4`, showButtonOk: true },
  [PHASE.SECOND_RUN_MONITORING]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_3`, showButtonOk: false },
  [PHASE.THIRD_EXECUTION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_5`, showButtonOk: true },
  [PHASE.THIRD_RUN_MONITORING]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_3`, showButtonOk: false },
  [PHASE.FOURTH_EXECUTION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_6`, showButtonOk: true },
  [PHASE.FOURTH_RUN_MONITORING]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_7`, showButtonOk: false },
  [PHASE.AIR_EXECUTION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_8`, showButtonOk: true },
  [PHASE.AIR_RUN_MONITORING]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_7`, showButtonOk: false },
  [PHASE.TMC_RUN_MONITORING]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_9`, showButtonOk: false },
  [PHASE.PIPE_EXECUTION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_10`, showButtonOk: true },
  [PHASE.PIPE_RUN_MONITORING]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION, workSupportMessage: key => `${key}.REQ_WS_161_TXT_7`, showButtonOk: false },
  [PHASE.SUCCESS]: { headerColor: HEADER_COLORS.SUCCESS, headerTitle: HEADER_TITLES.SUCCESS, workSupportMessage: key => `${key}.REQ_WS_161_TXT_11`, showButtonOk: true },
  [PHASE.EXECUTION_ERROR]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR, workSupportMessage: key => `${key}.REQ_WS_161_TXT_12`, showButtonOk: true },
  [PHASE.START_ERROR]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR, workSupportMessage: key => `${key}.REQ_WS_161_TXT_13`, showButtonOk: true },
  [PHASE.AIR_ERROR]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR, workSupportMessage: key => `${key}.REQ_WS_161_TXT_14`, showButtonOk: true },
  [PHASE.AIR_FLUID_ERROR]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR, workSupportMessage: key => `${key}.REQ_WS_161_TXT_15`, showButtonOk: true },
  [PHASE.BRAKE_ERROR]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR, workSupportMessage: key => `${key}.REQ_WS_161_TXT_16`, showButtonOk: true },
  [PHASE.PIPE_ERROR]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR, workSupportMessage: key => `${key}.REQ_WS_161_TXT_17`, showButtonOk: true },
  [PHASE.FAILED]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR, workSupportMessage: () => 'individual.error_communication_error', showButtonOk: true },
};

/** 実行処理 で使用する phase ごとの情報 */
export const PHASE_INFO_FOR_ROUTINE = {
  [PHASE.FIRST_EXECUTION]: { apiType: 'first', monitorPhase: PHASE.FIRST_RUN_MONITORING, },
  [PHASE.SECOND_EXECUTION]: { apiType: 'second', monitorPhase: PHASE.SECOND_RUN_MONITORING },
  [PHASE.THIRD_EXECUTION]: { apiType: 'third', monitorPhase: PHASE.THIRD_RUN_MONITORING },
  [PHASE.FOURTH_EXECUTION]: { apiType: 'fourth', monitorPhase: PHASE.FOURTH_RUN_MONITORING },
  [PHASE.AIR_EXECUTION]: { apiType: 'air', monitorPhase: PHASE.AIR_RUN_MONITORING },
  [PHASE.AIR_RUN_MONITORING]: { apiType: 'tmc', monitorPhase: PHASE.TMC_RUN_MONITORING, },
  [PHASE.PIPE_EXECUTION]: { apiType: 'pipe', monitorPhase: PHASE.PIPE_RUN_MONITORING }
};

/** 実行監視画面で使用する phase ごとの情報 */
export const PHASE_INFO_FOR_MONITOR = {
  [PHASE.FIRST_RUN_MONITORING]: { nextPhase: PHASE.SECOND_EXECUTION },
  [PHASE.SECOND_RUN_MONITORING]: { nextPhase: PHASE.THIRD_EXECUTION },
  [PHASE.THIRD_RUN_MONITORING]: { nextPhase: PHASE.FOURTH_EXECUTION },
  [PHASE.FOURTH_RUN_MONITORING]: { nextPhase: PHASE.AIR_EXECUTION },
  [PHASE.TMC_RUN_MONITORING]: { nextPhase: PHASE.PIPE_EXECUTION },
};

/** ルーチン実行またはルーチン結果確認が「異常終了」の際の async 情報 */
export const ASYNC_ERROR_INFO = {
  [error.WSP_161_AIR_BLEEDING_FAILED]: { nextPhase: PHASE.AIR_ERROR },
  [error.WSP_161_BREAK_ABNORMAL_FAILED]: { nextPhase: PHASE.BRAKE_ERROR },
  [error.WSP_161_PIPE_ABNORMAL_FAILED]: { nextPhase: PHASE.PIPE_ERROR },
  [error.WSP_161_AIR_ENTERS_FAILED]: { nextPhase: PHASE.AIR_FLUID_ERROR },
};